import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Route } from '@angular/router';
import { MpapComponent } from './mpap/mpap.component';
import { HelpingHandsComponent } from './helping-hands/helping-hands.component';
import { SharedDesktopModule} from "@brightside-web/shared/desktop";
import {BrightsideUiModule} from "@brightside/brightside-ui";

import { MicroUiMoleculeModule } from '@micro-ui/molecule';

import {SharedDisplayModule} from "@brightside-web/shared/display";
import {TranslateModule} from "@ngx-translate/core";

export const desktopFeatureProgramsRoutes: Route[] = [
  {
    path: 'mpap',
    component: MpapComponent
  },
  {
    path: 'helping-hands',
    component: HelpingHandsComponent
  },
];

@NgModule({
  imports: [
    BrightsideUiModule,
    CommonModule,
    MicroUiMoleculeModule,
    RouterModule.forChild(desktopFeatureProgramsRoutes),
    SharedDesktopModule,
    SharedDisplayModule,
    TranslateModule,
  ],
  declarations: [MpapComponent, HelpingHandsComponent],
})
export class DesktopFeatureProgramsModule {}
